export default __webpack_public_path__ + "spotify-sqr-v1.svg";